import React from 'react';

const MinBorrowerLine = ({ colour = '#000000', width = '6', height = '24', style = {} }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 6 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
            preserveAspectRatio="none"
        >
            <rect x="2" y="0" width="2" height={height} fill={colour} rx="1" />
            {/* Shadow/border effect */}
            <rect x="1.5" y="0" width="3" height={height} fill="none" stroke={colour} strokeWidth="0.5" strokeOpacity="0.3" rx="1.5" />
        </svg>
    );
};

export default MinBorrowerLine;
